export const BASEBALL_DIAMETER_INCHES = 2.9;
